import React, { useContext, useEffect } from "react";
import { storeContext } from "../../context/context";
import "./ProductCard.css";
import "./GridCard.css";
import "./GridCardResponsive.css";
import "./spinner.css";
import { useStore } from "../../context/store.provider";
import { priceFormatter } from "../admin/algoritem";
import { useState } from "react";
import { set } from "firebase/database";
// import CartOrderForm from './CartOrderForm';

function ProductCard() {
  const {
    setTotalPrice,
    setNumProducts,
    storeData,
    searchData,
    setSearchData,
  } = useContext(storeContext);
  //, handleFilterKeyInput
  const {
    filteredStoreProducts,
    setChoosenProducts,
    choosenProducts,
    storeProducts,
  } = useStore();
  const [productsId, setProductsId] = useState([]);
  // const {  imgUrl, name, cattegory, price } = SearchData;

  const handleClickAddToCart = (id, category, imgUrl, price, productName) => {
    // here condition if its already pressed before add

    const newProduct = {
      id: id,
      category: category,
      imgUrl: imgUrl,
      price: price,
      productName: productName,
      productAmount: 1,
    };
    console.log(newProduct);
    const newIdList = [...productsId];
    if (!productsId.includes(id)) newIdList.push(id);
    setProductsId(newIdList);
    // choosenProducts.forEach(product => {
    //   if(product.id==id){
    //     console.log(product);
    //   }
    // });
    if (!productsId.includes(id)) {
      setNumProducts((prev) => prev + 1);
      const allProducts = [...choosenProducts];
      // here need to create a new
      // console.log(id, category, imgUrl, price, productName);
      allProducts.push(newProduct);
      setChoosenProducts(allProducts);
      setTotalPrice((prev) => prev + price);
    }
  };
  console.log(productsId);
  // const fillterData = searchData.filter((product) => {
  //   if (value === '') {
  //     return product
  //   }
  //   else {
  //     // console.log(product);
  //     setTimeout(() => {
  //       console.log((Object.values(product).includes(value)))
  //     }, 500);
  //   }
  // })
  // useEffect(() => {
  //   setTimeout(() => {
  //     const copiedData = [...storeData]
  //     setSearchData(copiedData)
  //   }, 500);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [storeData])
  console.log(filteredStoreProducts.length);
  return (
    <div className="products-con">
      {storeProducts.length === 0 ? (
        <div className="spinner-con">
          <h1 className="spinner">כל בו אפרת המוצרים נטענים...</h1>
          <div className="spiner1"></div>
        </div>
      ) : (
        filteredStoreProducts.map(
          ({salePrice, id, category, imgUrl, price, productName, outOfStock }) => {
            if (price != 0) {
              return (
                <div className="container" key={id}>
                  <div className="card">
                    <div className="imgBx">
                      <img src={imgUrl} alt={productName} />
                      <div className="contentBx">
                        <h2 className="text-card">{productName}</h2>
                        <div className="size">
                          <h3 className="text-card">{category}</h3>
                        </div>
                        {/* <br /><br /><br /><br /> */}
                        <div className="color">
                         {salePrice? <div><h3 className="text-card" style={{textDecoration:"line-through"}}>{priceFormatter.format(price)}</h3>
                         <h3 className="text-card">
                           מבצע {priceFormatter.format(salePrice)}
                          </h3></div>
                          : <h3 className="text-card">
                          {priceFormatter.format(price)}
                        </h3>
                          }
                        </div>
                        <button
                          onClick={() =>
                            handleClickAddToCart(
                              id,
                              category,
                              imgUrl,
                              price,
                              productName
                            )
                          }
                        >
                          Add To Cart
                        </button>
                      </div>
                    </div>
                    <button
                      id="add-btn"
                      onClick={() =>
                        handleClickAddToCart(
                          id,
                          category,
                          imgUrl,
                          price,
                          productName
                        )
                      }
                    >
                      <i className="fa-solid fa-cart-plus"></i>
                    </button>
                  </div>
                </div>
              );
            }
            if (filteredStoreProducts.length === 0) {
              console.log("first");
              return (
                <>
                  <h1>לא נמצאו תוצאות לחיפוש זה, נסו לחפש פחות ספציפי</h1>
                </>
              );
            }
          }
        )
      )}
    </div>
  );
}

export default ProductCard;
/* {!storeData ? <h1>hello world</h1> : storeData.map(({ id, category, imgUrl, price, productName }) => <ProductCard keyforProduct={id} name={productName} imgUrl={imgUrl} cattegory={category} price={price} id={id} />)*/
